import { ContactAPI } from "../helpers/contact-api";
import { Modal } from "bootstrap";

const resetModal = () => {
    document.querySelector("#content-loading").classList.remove("d-none");

    document.querySelector("#content-done").classList.add("d-none");
    document.querySelector("#content-fail").classList.add("d-none");

    const btnClose = document.querySelector("#btn-close");
    btnClose.setAttribute("disabled", "");
    btnClose.classList.add("btn-secondary");
    btnClose.classList.remove("btn-success");
};

const init = () => {
    // top bar active item
    document.querySelector("#nav-item-index").classList.remove("active");
    document.querySelector("#nav-item-contact").classList.add("active");

    const form = document.querySelector("#send-contact-form");
    form.querySelector("#send-contact-btn").addEventListener(
        "click",
        async (event) => {
            event.preventDefault();
            if (!form.checkValidity()) {
                form.classList.add("was-validated");
                return;
            }

            // show modal
            const modal = new Modal(
                document.querySelector("#send-contact-modal"),
                {
                    focus: true,
                    keyboard: true,
                },
            ).show();

            const data = {
                email: form.querySelector("#emailaddress"),
                message: form.querySelector("#message"),
                fullname: form.querySelector("#fullname"),
                subject: form.querySelector("#subject"),
            };

            // don't wait for response
            new ContactAPI().send(
                data.email.value,
                data.message.value,
                data.fullname.value,
                data.subject.value,
            );

            const clearForm = () => {
                form.classList.remove("was-validated");
                data.email.value = "";
                data.message.value = "";
                data.fullname.value = "";
                data.subject.value = "";
            };

            const modalDone = (success) => {
                document
                    .querySelector("#content-loading")
                    .classList.add("d-none");

                if (success) {
                    document
                        .querySelector("#content-done")
                        .classList.remove("d-none");
                }

                if (!success) {
                    document
                        .querySelector("#content-fail")
                        .classList.remove("d-none");
                }

                const btnClose = document.querySelector("#btn-close");
                btnClose.removeAttribute("disabled");
                btnClose.classList.remove("btn-secondary");
                btnClose.classList.add("btn-success");
            };

            modalDone(true);
            clearForm();
        },
    );

    document.querySelector("#btn-close").addEventListener("click", (event) => {
        event.preventDefault();
        resetModal();
    });
};

init();
